import { Container, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ATOM_ICON from '@/assets/images/presentation/atom-icon.png';
import GENTLEMAN_ICON from '@/assets/images/presentation/gentleman.png';
import HAND_ICON from '@/assets/images/presentation/hand-return-icon.png';

import { TestimonialsCarousel } from '@/components/ui/features/presentation/PresentationReviews/components/TestimonialsCarousel';
import { WhyReasons } from '@/components/ui/features/presentation/PresentationReviews/components/WhyReasons';

export const PresentationReviews: FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Text mt={6} fontSize="2xl" textAlign="center" fontFamily="heading" fontWeight="bold">
        {t('newEventPage.hereIsWhyTitle')}
      </Text>
      <Flex
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent="space-between"
        alignItems="flex-start"
        mt={8}
        gap={10}
      >
        <WhyReasons
          src={ATOM_ICON}
          alt={t('newEventPage.why.whyOneTitle')}
          title={t('newEventPage.why.whyOneTitle')}
          description={t('newEventPage.why.whyOneDescription')}
        />
        <WhyReasons
          src={HAND_ICON}
          alt={t('newEventPage.why.whyTwoTitle')}
          title={t('newEventPage.why.whyTwoTitle')}
          description={t('newEventPage.why.whyTwoDescription')}
        />
        <WhyReasons
          src={GENTLEMAN_ICON}
          alt={t('newEventPage.why.whyThreeTitle')}
          title={t('newEventPage.why.whyThreeTitle')}
          description={t('newEventPage.why.whyThreeDescription')}
        />
      </Flex>
      <Flex mt={12} justifyContent="center" w="full">
        <TestimonialsCarousel />
      </Flex>
    </Container>
  );
};
